import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import useTheme from "hooks/useTheme";
import { getAllContactsByUser } from "actions/contacts";

import UserIconRoundIcon from "theme/icons/UserIconRound";

const SelectFromContactsModal = ({ isOpen, setIsOpen, setReceiverAccount, setReceiverFriendlyName, setReceiverProfileImage }) => {
	const dispatch = useDispatch();
	const { appLanguage, themeColor } = useTheme();

	const contacts = useSelector((state) => state.Contacts);

	useEffect(() => {
		dispatch(getAllContactsByUser());

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex flex-col w-full space-x-4 items-center">
									<Dialog.Title as="h3" className="flex-col items-center font-medium leading-6 text-gray-900">
										<p className={`text-lg ${themeColor?.text}`}>{appLanguage?.selectContact}</p>
									</Dialog.Title>
									<div className="w-full min-h-fit max-h-[600px] overflow-auto py-2">
										{contacts &&
											contacts.map((contact, index) => (
												<div
													className="flex w-full items-center space-x-2"
													key={index}
													onClick={() => {
														setReceiverAccount(contact["account-address"]);
														setReceiverFriendlyName(contact["friendly-name"]);
														setReceiverProfileImage(contact["profile-image"]);
														setIsOpen(false);
													}}
												>
													{contact["profile-image"] ? (
														<img
															className={`w-7 h-7 object-cover object-center`}
															src={contact["profile-image"]}
															alt="temp"
														/>
													) : (
														<UserIconRoundIcon className={`w-7 h-7 `} fill={themeColor?.hex} />
													)}
													<div className="flex flex-col w-full px-3 py-2 rounded-xl cursor-pointer hover:shadow-lg">
														<p className={`text-md font-bold ${themeColor?.text}`}>
															{contact["friendly-name"]}
														</p>
														<p className={`text-xs ${themeColor?.text}`}>
															{contact?.["account-address"].slice(0, 5) +
																"..." +
																contact?.["account-address"].slice(-5)}
														</p>
													</div>
												</div>
											))}
									</div>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default SelectFromContactsModal;
